<script setup lang="ts">
import { useRoute } from 'vue-router'
import { onMounted, onUnmounted, ref } from 'vue'
import { IonPage } from '@ionic/vue'
import SekaiMainPage from './SekaiMainPage.vue'
import type { ReturnedUniverse } from '@/services/universe'
import { universeService } from '@/services/universe'
import type { Chat } from '@/types'
import LoadingComponent from '@/components/LoadingComponent.vue'
import { generateChatFromReturnedUniverse } from '@/utils/generateChatFromUniverse'
import { useChatsStore } from '@/store/chats'
import { useBgm } from '@/composables/useBgm'
import PageHeader from '@/components/PageHeader.vue'

const { params, query, path } = useRoute()

const chat = ref<Chat | undefined>()
const chatStore = useChatsStore()
const prevChatId = ref<string>()
const bgm = useBgm()

// use the universeId to fetch the universe details
onMounted(async () => {
  if (Array.isArray(params.id)) {
    throw new TypeError('params.id should be a string')
  }
  else {
    const universeId = params.id
    console.debug(params, query, path)
    let universe: ReturnedUniverse | null = null
    if (path.includes('newsekai')) {
      console.log('This is a new Sekai')
      const res = await universeService.getSekaiInfoById(universeId)
      if (res.success) {
        universe = res.data
      }
    }
    else {
      console.log('This is not a Sekai')
      universe = await universeService.getUniverseById(universeId)
    }
    if (!universe) {
      return
    }
    chat.value = generateChatFromReturnedUniverse(universe)

    prevChatId.value = chatStore.currentChatId
    chatStore.setCurrentChatId(chat.value.chatId)

    bgm.playBgm(chat.value.bgmUrl)
  }
})

onUnmounted(() => {
  chatStore.setCurrentChatId(prevChatId.value || '')
  bgm.stopBgm()
})
</script>

<template>
  <ion-page>
    <loading-component v-if="!chat" />
    <div v-else class="sekai-wrapper">
      <sekai-main-page
        :chat="chat"
        :next-chat="undefined"
        :is-loading="false"
        :is-preview="false"
        :active="true"
        @play-bgm="bgm.playBgmByTap"
      />
    </div>
    <page-header :is-single-sekai="true" />
  </ion-page>
</template>

<style scoped>
.sekai-wrapper {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
}
</style>
